module.exports = __webpack_public_path__ + "img/art-4.7c927adf.png";